/**
 * Whether a seller's subscription lets them into the app right now.
 *
 * Voolist is for paying sellers, so this is the one rule every screen that asks reads: access is
 * open while the subscription is active, while Stripe retries a failed renewal (past_due), and after
 * a cancellation until the paid period ends. A first payment that never went through opens nothing.
 *
 * @param {object|null} user - the signed-in seller, as the server sends it
 * @param {Date} [now]
 * @returns {boolean}
 */
export function hasPaidAccess (user, now = new Date()) {
  if (!user) return false;

  const { status, subscriptionStatus, stripeSubscriptionId, currentPeriodEnd } = user;

  // incomplete / incomplete_expired: the first payment never succeeded.
  if (['incomplete', 'incomplete_expired'].includes(subscriptionStatus)) return false;

  if (!stripeSubscriptionId) return false;

  return (
    status === 'active' ||
    status === 'past_due' ||
    (status === 'cancelled' && Boolean(currentPeriodEnd) && new Date(currentPeriodEnd) > now)
  );
}

export default hasPaidAccess;
